import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './LoadingAnalysis.module.css';

const MESSAGES = [
  'Analyzing your AI posture...',
  'Calculating governance maturity...',
  'Cross-referencing security signals...',
  'Building your executive report...',
];

export default function LoadingAnalysis({ onDone }) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const messageTimer = setInterval(() => {
      setMessageIndex((i) => Math.min(i + 1, MESSAGES.length - 1));
    }, 650);
    const doneTimer = setTimeout(onDone, 2700);
    return () => {
      clearInterval(messageTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <motion.div
      className={styles.loading}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <div className={styles.spinner}>
        <div className={styles.spinnerRing} />
        <div className={styles.spinnerCore} />
      </div>

      <AnimatePresence mode="wait">
        <motion.p
          key={messageIndex}
          className={styles.message}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.25 }}
        >
          {MESSAGES[messageIndex]}
        </motion.p>
      </AnimatePresence>
    </motion.div>
  );
}
